import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { getDayClass } from '../calendarCore/utils/getDayClass';
import DayIndicator from '../calendarCore/DayIndicator';
import { getLabels } from '../labels';
export default function DayOfWeekCell({ day, disablePast, testId }) {
    const { dayOfWeekLabels } = getLabels().calendar;
    const dayOfWeek = dayOfWeekLabels[day.date.getDay()];
    const dayOfMonth = day.date.getDate().toString().padStart(2, '0');
    const isChoosable = !day.alert && (!day.isInThePast || !disablePast) && !day.isBeforeMinDate && !day.isAfterMaxDate;
    return (_jsxs("button", { className: classNames('flex h-16 w-15 shrink-0 flex-col items-center border text-sm', getDayClass(day), {
            'cursor-not-allowed opacity-40': !isChoosable,
            'cursor-pointer': isChoosable,
        }), children: [_jsxs("div", { className: classNames('pt-1 text-center leading-6', { 'text-fg-disabled opacity-40': day.alert }), "data-testid": testId.append('name'), children: [dayOfWeek, _jsx("br", {}), dayOfMonth] }), _jsx(DayIndicator, { day: day, testId: testId })] }, day.key));
}
